import { type ActionItem } from 'shared/ui'
import { type Phone } from 'entities/Phone/model/Phone'
import { ReleaseNumberStore } from 'entities/Phone/ui/actions/releaseNumber/ui'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export const releaseNumber = (
  phone: Phone,
  entities: IEntitiesStore,
  onSuccess: () => Promise<void>
): ActionItem => {
  return {
    icon: 'delete',
    text: 'Release number',
    onAction: () => {
      new ReleaseNumberStore(phone, onSuccess, entities)
    },
  }
}
